import { useMemo } from 'react';
import type { IModuleDefinition, IRecord } from '@platform/core/types';
import { useLawRecordsQuery } from './api/lawApi';
import type { ILawRecords } from './ILawRecords';
import { lawSourcesOf } from './lawSourcesOf';

const NONE: IRecord[] = [];

/** Записи моделі закону законопроєкту (прототип v4 lawViz R(k)): усі дочірні типи моделі, що посилаються на нього, одним запитом. */
export function useLawRecords(ws: string, module: IModuleDefinition, rtKey: string, draftId: string): ILawRecords {
  const sources = useMemo(() => lawSourcesOf(module, rtKey), [module, rtKey]);
  const { data, isLoading } = useLawRecordsQuery({ ws, draftId, sources }, { skip: !draftId || !sources.length });
  return useMemo(() => ({ of: (key: string) => data?.[key] ?? NONE, loading: isLoading }), [data, isLoading]);
}
